export default __webpack_public_path__ + "static/media/mail-lg.14c5ac42.svg";